import { IModelMapping } from "./generic/model.mapping";
import { AddressMapping } from "./address.mapping";
import { LegacyInfoMapping } from "./customer-legacy-info.mapping";
import { LookUpTypeMapping } from "./lookup-type.mapping";
import { SavedAddressMapping } from "./saved-address.mapping";
import { SavedContactMapping } from "./saved-contact.mapping";
import { ICustomerResultDtoModel } from "../models/customer/dto/customer-result-dto.model";
import { ICustomerResultModel } from "../models/customer/customer-result.model";
import { IJControlCustomerMessageDtoModel } from "../models/legacy-info/jcontrol-customer-message-dto.model";
import { ShippingMapping } from "./shipping.mapping";
import { PaymentMapping } from "./payment.mapping";
import { ApplicationContextService } from "../services/application-context.service";
import { ILegacyInfoModel } from "../models/legacy-info/legacy-info.model";
import { ISavedAddressModel } from "../models/saved-address/saved-address.model";

export class CustomerMapping implements IModelMapping<ICustomerResultDtoModel, ICustomerResultModel> {

    constructor(private applicationContextService?: ApplicationContextService){}

    private addressMapping: AddressMapping = new AddressMapping();
    private shippingMapping: ShippingMapping = new ShippingMapping();
    private paymentMapping: PaymentMapping = new PaymentMapping();
    private savedAddressMapping: SavedAddressMapping = new SavedAddressMapping();
    private savedContactMapping: SavedContactMapping = new SavedContactMapping();
    private legacyInfoMapping: LegacyInfoMapping = new LegacyInfoMapping();
    private lookUpTypeMapping: LookUpTypeMapping = new LookUpTypeMapping();

    toApplicationModel(model: ICustomerResultDtoModel): ICustomerResultModel {
        return {
            id: model.id,
            accountNumber: model.accountNumber,
            name: model.accountName,
            customerType: model.customerType ? this.lookUpTypeMapping.toApplicationModel(model.customerType) : undefined,
            accountStatus: model.accountStatus ? this.lookUpTypeMapping.toApplicationModel(model.accountStatus) : undefined,
            defaultContact: model.defaultContact ? this.savedContactMapping.toApplicationModel(model.defaultContact) : undefined,
            defaultAddress: model.defaultAddress ? this.savedAddressMapping.toApplicationModel(model.defaultAddress) : undefined,
            defaultBillToAddress: model.defaultBillToAddress ? this.savedAddressMapping.toApplicationModel(model.defaultBillToAddress) : undefined,
            defaultShipToAddress: model.defaultShipToAddress ? this.savedAddressMapping.toApplicationModel(model.defaultShipToAddress) : undefined,
            defaultPaymentMethod: model.defaultPaymentMethod ? this.lookUpTypeMapping.toApplicationModel(model.defaultPaymentMethod) : undefined,
            defaultShippingMethod: model.defaultShippingMethodId ? {id: model.defaultShippingMethodId} : undefined,
            legacyInfo: model.legacyInfo ? this.legacyInfoMapping.toApplicationModel(model.legacyInfo) : undefined,
            internalComment: model.internalComment,
            isOnStop: model.isOnStop
        } as ICustomerResultModel;
    }
    toDtoModel(model: ICustomerResultModel): ICustomerResultDtoModel {
        return {
            id: model.id,
            accountNumber: model.accountNumber,
            accountName: model.name,
            customerType: model.customerType ? this.lookUpTypeMapping.toDtoModel(model.customerType) : undefined,
            accountStatus: model.accountStatus ? this.lookUpTypeMapping.toDtoModel(model.accountStatus) : undefined,
            defaultAddress: model.defaultAddress ? this.savedAddressMapping.toDtoModel(model.defaultAddress) : undefined,
            defaultContact: model.defaultContact ? this.savedContactMapping.toDtoModel(model.defaultContact) : undefined,
            legacyInfo: model.legacyInfo ? this.legacyInfoMapping.toDtoModel(model.legacyInfo) : undefined,
            internalComment: model.internalComment,
            isOnStop: model.isOnStop
        } as ICustomerResultDtoModel
    }
    toDtoModels(models: ICustomerResultModel[]): ICustomerResultDtoModel[] {
        return models.map(m => this.toDtoModel(m));
    }
    toApplicationModels(models: ICustomerResultDtoModel[]): ICustomerResultModel[] {
        return models.map(m => this.toApplicationModel(m));
    }
    toJControlCustomerMessageModel(model: ICustomerResultModel, type: string): IJControlCustomerMessageDtoModel {

        return {
            messageType: type,
            legacyId: model.legacyInfo ? this.toJControlCustomerLegacyId(model.legacyInfo) : undefined,
            id: model.id,
            accountNumber: model.accountNumber,
            accountName: model.name,
            accountStatus: model.accountStatus.code,
            billingAddress: this.addressMapping.toJControlAddressModel(this.getBestCustomerAddressFromCustomerResult(model, "billing")),
            deliveryAddress:this.addressMapping.toJControlAddressModel(this.getBestCustomerAddressFromCustomerResult(model, "shipping")),
            defaultShippingMethod: model.defaultShippingMethod ? this.shippingMapping.toJControlShippingMethodModel(model.defaultShippingMethod) : undefined,
            defaultPaymentMethod: model.defaultPaymentMethod ? this.paymentMapping.toJControlPaymentMethodModel(model.defaultPaymentMethod) : undefined,
            telephoneNumber: model.defaultContact && (model.defaultContact.telephoneNumber || model.defaultContact.mobileNumber) ? (model.defaultContact.telephoneNumber ? model.defaultContact.telephoneNumber : model.defaultContact.mobileNumber) : undefined,
            emailAddress: model.defaultContact && model.defaultContact.emailAddress ? model.defaultContact.emailAddress : undefined,
            isOnStop: model.isOnStop ? model.isOnStop : undefined
        } as IJControlCustomerMessageDtoModel;
    }

    toJControlCustomerLegacyId(legacyInfo: ILegacyInfoModel): number {

        let branch = this.applicationContextService?.getBranchCodeFromUrl();
        let prop = `accountId_${branch}` as keyof typeof legacyInfo;
        let x = legacyInfo[prop] as number;

        return x;

    }

    //Using the customers result data, determine the best address to use for billing and shipping actions
   getBestCustomerAddressFromCustomerResult(customer: ICustomerResultModel, type: string): ISavedAddressModel | undefined {

    if(type == 'billing' && customer.defaultBillToAddress){
       return customer.defaultBillToAddress

    }
    if(type == 'shipping' && customer.defaultShipToAddress){
      return customer.defaultShipToAddress
    }

    if(customer.defaultAddress){
       return customer.defaultAddress
    }

    return undefined;

 }

}